import { FC, PropsWithChildren } from 'react';

import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  BenefitText,
  Container,
  ContentText,
  InfoBadge,
  InfoContainer,
  InfoText,
  SectionTitle,
  StyledImage,
  Title,
} from './styled';

const walmartMembershipImg = require('./walmart-membership-image.png');

type WalmartMembershipProps = {
  title?: string;
};

export const WalmartMembership: FC<PropsWithChildren<WalmartMembershipProps>> = ({ title }) => {
  const { formatMessage } = useIntl();

  const enableWalmartPlusMonthlyTrialOffer = useFlag(
    LaunchDarklyFlag.ENABLE_WALMART_PLUS_TRIAL_OFFER_MONTHLY
  );

  const text = enableWalmartPlusMonthlyTrialOffer
    ? {
        sectionTitle: 'dontHaveWalmartAccountMonthly',
        contentText: 'walmartMembershipSignUpMonthly',
        infoText: 'walmartMembershipDealMonthly',
      }
    : {
        sectionTitle: 'dontHaveWalmartAccount',
        contentText: 'walmartMembershipSignUp',
        infoText: 'walmartMembershipDeal',
      };

  return (
    <>
      <SectionTitle>{title || formatMessage({ id: text.sectionTitle })}</SectionTitle>
      <Container>
        <StyledImage source={walmartMembershipImg} />
        <Title>{formatMessage({ id: 'royalPerksMembersEnjoy' })}</Title>
        <BenefitText>{formatMessage({ id: 'walmartPlusBenefit' })}</BenefitText>
        <ContentText>{formatMessage({ id: text.contentText })}</ContentText>
        <InfoContainer>
          <InfoBadge>
            <InfoText>{formatMessage({ id: text.infoText })}</InfoText>
          </InfoBadge>
        </InfoContainer>
      </Container>
    </>
  );
};
